import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { toast } from "react-hot-toast";

// Async Thunks

// Create a new career application
export const createCareer = createAsyncThunk(
    "career/createCareer",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post("/carrier", formData);
            toast.success("Application submitted successfully!");
            return response.data;
        } catch (error) {
            const message = error.response?.data?.error || "Failed to submit application.";
            toast.error(message);
            return rejectWithValue(message);
        }
    }
);

const careerSlice = createSlice({
    name: "career",
    initialState: {
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Career
            .addCase(createCareer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCareer.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(createCareer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default careerSlice.reducer;
